import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import defaultImage from "../../../media/background_images/default-image-sapore.jpg";

export class ProductsLineFeature {
    constructor(application, id) {
        this._application = application
        this._categoryId = id
        this._familyInformation = {};
        this._familiesInformation = []
        this._articles = []
        this.loaded = false

        makeObservable(this, {
            _familyInformation: observable,
            _familiesInformation: observable,
            _articles: observable,
            _loaded: observable,
            loaded: computed,
        });
    }

    async load() {
        await this.getCategoriesArticles()
        await this.getArticlesCategories()
        this._finishedLoading()
    }

    _finishedLoading() {
        this._loaded = true;
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    async getCategoriesArticles() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this._articles = this.convertArticlesResponse(response.articles())
            },
            handlesError: (response) => {
                // response.errors().map(error => {
                //     this.showAlert(error);
                // })
                console.log("Error fetching article price list.")
            }
        });
        return this._application.apiClient().getCategoriesArticles(this._categoryId, this._application.getCustomer() , responseHandler);
    }

    async getArticlesCategories() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                const articlesCategories = response.articlesCategories();
                this._categories = this.convertArticlesCategoriesResponse(articlesCategories)
                this._familiesInformation = this.familiesInformationFrom(articlesCategories)
                const currentCategory = articlesCategories.find(category => category.name === this._categoryId)
                this._familyInformation = {
                    Id: currentCategory.name,
                    ImagenLineaProducto: this.imagenLineaProductoOrDefault(currentCategory),
                    ImagenLogoProduct: this.imagenLogoProductOrDefault(currentCategory),
                    ImagenBannerProducto: this.imagenBannerProductoOrDefault(currentCategory),
                    Titulo: currentCategory.title,
                    Descripcion: currentCategory.description
                }
            },
            handlesError: (response) => {
                // response.errors().map(error => {
                //     this.showAlert(error);
                // })
                console.log("Error fetching articles.")
            }
        });
        return this._application.apiClient().getArticlesCategories(responseHandler, this._application.getCustomer());
    }

    imagenLogoProductOrDefault(currentCategory) {
        let url = currentCategory.whiteLogoImage;
        if (url.includes('invalid_url')){
            url = defaultImage
        }

        return url;
    }

    imagenLineaProductoOrDefault(currentCategory) {
        let url = currentCategory.mainImage;
        if (url.includes('invalid_url')){
            url = defaultImage
        }

        return url;
    }

    imagenBannerProductoOrDefault(currentCategory) {
            let url = currentCategory.bannerImage;
            if (url.includes('invalid_url')){
                url = defaultImage
            }
            return url;
        }

    articleImageOrDefault(pricedArticle) {
        let url = pricedArticle.article.file;
        if (url.includes('invalid_url')){
            url = defaultImage
        }

        return url;
    }

    convertArticlesResponse(articlePriceList) {
        return articlePriceList.map((pricedArticle) => {return {
            Id: pricedArticle.article.code,
            EsDemo: false,
            Producto: {
                Archivos: this.articleImageOrDefault(pricedArticle),
                Nombre: pricedArticle.article.name,
                NombreFantasia: pricedArticle.article.fantasyName,
            }
        }
        })
    }

    convertArticlesCategoriesResponse(articlesCategories) {
        return articlesCategories.map((category) => {return {
            Id: category.name,
            Nombre: category.name,
            ImagenFamilia: category.mainImage,
            ImagenLogoFamilia: category.blackLogoImage
        }
        })
    }

    familiesInformationFrom(articlesCategories) {
        return articlesCategories.map((category) => {return {
                Id: category.name,
                Archivos: this.familyBlackLogoImageOrDefault(category),
                Titulo: category.title,
                Descripcion: category.description
            }
        })
    }

    familyBlackLogoImageOrDefault(family) {
        let url = family.blackLogoImage;
        if (url.includes('invalid_url')){
            url = defaultImage
        }

        return url;
    }

    familyId() {
        return this._familyInformation.Id;
    }

    familyTitle() {
        return this._familyInformation.Titulo;
    }

    familyDescription() {
        return this._familyInformation.Descripcion;
    }

    familyImage() {
        return this._familyInformation.ImagenLineaProducto;
    }

    familyBanner() {
        return this._familyInformation.ImagenBannerProducto;
    }

    familyLogo() {
        return this._familyInformation.ImagenLogoProduct;
    }

    families() {
        return this._familiesInformation;
    }

    articles() {
        return this._articles;
    }

    canAddProduct() {
        // FIXME: Duplicated code!
        const business = this._application.business();
        const userRoles = this._application.session().user().roles;
        return userRoles.includes(business.marketplace_operational_role()) || userRoles.includes(business.marketplace_general_administrator_role());
    }

}